import findIndex from 'lodash/findIndex';

/**
 * @param array
 * @param id
 * @returns {number}
 */
export const findIndexById = <T extends { id: any }>(array: T[], id: any) => findIndex(array, item => item.id === id);

type ConditionalArrayConfig<T> = { condition?: boolean; entries: T[] };

export const generateConditionalArray = <T>(configs: ConditionalArrayConfig<T>[]) => configs.reduce<T[]>(
    (accumulator, config) => {
        const { condition = true, entries } = config;

        return [
            ...accumulator,
            ...condition ? entries : [],
        ];
    },
    [],
);

export const getIncrementalArray = (numberOfItems: number): number[] => [...Array(numberOfItems + 1).keys()].slice(1);
